import Box from '@eversports/klimt-primitives/legacy/Box'
import Processing from '@eversports/klimt-primitives/legacy/Processing'
import Stack from '@eversports/klimt-primitives/legacy/Stack'
import Text from '@eversports/klimt-primitives/legacy/Text'

import useGetTopContentHeight from '../../hooks/useGetTopContentHeight'
import { Localized } from '../../localization/react'

import getNotificationBlocks from './helpers/get-notification-blocks'
import useNotifications from './hooks/useNotifications'
import Navigation from './Navigation'
import NoNotifications from './NoNotifications'
import NotificationBlock from './NotificationBlock'
import { NotificationConnection } from './Notifications.types'

interface Props {
  initiallyFetchedNotifications: NotificationConnection
  unreadNotificationsCount: number | null
}

const NotificationsComponent = ({ initiallyFetchedNotifications, unreadNotificationsCount }: Props) => {
  const { notifications, loading, fetchMore, hasMoreResults } = useNotifications({ initiallyFetchedNotifications })
  const { DESKTOP_TOP_CONTENT_HEIGHT } = useGetTopContentHeight(['NAVIGATION_BAR'])

  const notificationBlocks = getNotificationBlocks(notifications)

  return (
    <Box
      sx={{
        backgroundColor: 'limelite',
        minHeight: `calc(100vh - ${DESKTOP_TOP_CONTENT_HEIGHT}px)`,
        height: '100%',
      }}
      component="main"
    >
      <Stack margin="auto" maxWidth={{ xs: '100%', sm: '440px' }} gap={{ xs: 3, sm: 0 }} paddingBottom={4}>
        <Navigation unreadNotificationsCount={unreadNotificationsCount} />
        {notificationBlocks.length > 0 ? (
          <Stack gap={{ xs: 6, sm: 8 }}>
            {notificationBlocks.map((block) => (
              <NotificationBlock key={block.date} date={block.date} notifications={block.notifications} />
            ))}
            {hasMoreResults && (
              <Processing isLoading={loading}>
                <Box
                  sx={{ backgroundColor: 'limelite', borderRadius: 1, padding: 2, width: '100%', cursor: 'pointer' }}
                  onClick={fetchMore}
                >
                  <Text variant="small" sx={{ color: 'primarySelected', fontWeight: 'bold', textAlign: 'center' }}>
                    <Localized id="load-more-notifications-button" />
                  </Text>
                </Box>
              </Processing>
            )}
          </Stack>
        ) : (
          <NoNotifications />
        )}
      </Stack>
    </Box>
  )
}

export default NotificationsComponent
